/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetMyReservationCreditActivityPathParameters } from 'api/actions/get-my-reservation-credit-activity/get-my-reservation-credit-activity-path-parameters';
import { GetMyReservationCreditActivityResponse } from 'api/actions/get-my-reservation-credit-activity/get-my-reservation-credit-activity-response';

type GetMyReservationCreditActivityQueryParameters = Record<string, any>;

/**
 * The path of the GetMyReservationCreditActivity action.
 */
export const getMyReservationCreditActivityActionPath = new SweetPath<
  keyof GetMyReservationCreditActivityPathParameters
>('/reservations/credits/activity', { path: '{param}' });

/**
 * Creates a contextualized GetMyReservationCreditActivity actions.
 */
export default function createGetMyReservationCreditActivityAction(axios: AxiosInstance) {
  return function getMyReservationCreditActivityAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetMyReservationCreditActivityQueryParameters } = {}) {
    const path = getMyReservationCreditActivityActionPath.original;

    return axios.get<GetMyReservationCreditActivityResponse, GetMyReservationCreditActivityResponse>(path, {
      params: query,
      headers,
    });
  };
}
